<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="sidebar">
    <div class="sidebar-header-expanded">
      <a :href="$t('sidebar.homepageUrl')">
        <icon-comp class="logo" icon="logo" alt="Protolabs"></icon-comp>
      </a>
      <hr />
      <h3>{{ $t("sidebar.rapid") }}</h3>
      <p>{{ $t("sidebar.trustedBy") }}:</p>
      <div v-if="isAmerRegion" class="sidebar-logos">
        <div class="sidebar-logos-horizontal" style="margin-bottom: 10px">
          <img class="sidebar-lockheed" src="../assets/lockheed.png" />
          <img class="sidebar-hp" src="../assets/hp.png" />
        </div>
        <div class="sidebar-logos-horizontal">
          <img class="sidebar-nasa" src="../assets/nasa.png" />
          <img class="sidebar-pepsico" src="../assets/pepsico.png" />
        </div>
      </div>
      <div v-else class="sidebar-logos">
        <div class="sidebar-logos-horizontal">
          <img class="sidebar-michelin" src="../assets/michelin.png" />
          <img class="sidebar-pepsico" src="../assets/pepsico.png" />
        </div>
        <div class="sidebar-logos-horizontal">
          <img class="sidebar-epson" src="../assets/epson.png" />
          <img class="sidebar-mahle" src="../assets/mahle.png" />
        </div>
      </div>
    </div>
    <div class="sidebar-header-collapsed">
      <a :href="$t('sidebar.homepageUrl')">
        <icon-comp
          class="logo-mini"
          icon="logo-white"
          alt="Protolabs"
        ></icon-comp>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'vuex';
import { IState } from '@/store';

export default {
  name: 'sidebar-comp',
  computed: {
    ...mapState({
      defaultRegionCode: (state: any) => (state as IState).geolocation.defaultRegionCode,
    }),
    isAmerRegion() {
      return this.defaultRegionCode === 'AMER';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_layout.scss";

.sidebar {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  background: $gray-dark-2;
  width: $sidebar-width;
  text-align: center;

  h3 {
    width: 330px;
    margin: 0 0 25px 0;
    color: $white;
    line-height: 1.5;
    font-size: 18px;
    font-weight: 100;
    font-family: $font;
  }

  p {
    margin-top: 20px;
    color: $secondary-gray;
  }

  hr {
    display: block;
    opacity: 1;
    margin: 35px auto;
    border: none;
    width: 170px;
    height: 4px;
    background: $proto-blue;
  }

  .logo {
    position: static;
    margin: 90px auto 0;
    transform: translate(0);
  }

  &-logos {
    width: 100%;
    height: 200px;

    &-horizontal {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 50%;
    }
  }

  &-lockheed {
    width: 180px;
    margin-left: 50px;
  }

  &-hp {
    width: 73px;
    transform: translateY(15px);
    margin-right: 74px;
  }

  &-nasa {
    width: 75px;
    transform: translateY(-10px);
    margin-left: 80px;
  }

  &-pepsico {
    width: 150px;
    margin-right: 50px
  }

  &-michelin {
    width: 150px;
    margin-left: 50px;
  }

  &-epson {
    width: 150px;
    margin-left: 50px;
  }

  &-mahle {
    width: 150px;
    margin-right: 50px
  }

  .sidebar-header-expanded {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .sidebar-header-collapsed {
    display: none;
  }

  @media screen and (max-width: 1200px) {
    width: $sidebar-width-1200;

    .logo {
      width: 50%;

      :deep(svg) {
        height: auto;
      }
    }

    hr {
      width: 40%;
    }

    h3 {
      font-size: 16px;
    }

    &-logos {
      height: 130px;
    }

    &-lockheed {
      width: 120px;
      margin-left: 30px;
    }

    &-hp {
      width: 50px;
      transform: translateY(5px);
      margin-right: 45px;
    }

    &-nasa {
      width: 60px;
      transform: translateY(-10px);
      margin-left: 53px;
    }

    &-pepsico {
      width: 100px;
      margin-right: 30px
    }

    &-michelin {
      width: 100px;
      margin-left: 30px
    }

    &-epson {
      width: 100px;
      margin-left: 30px
    }

    &-mahle {
      width: 100px;
      margin-right: 30px
    }
  }

  @media (max-width: 800px) {
    width: $sidebar-width-800;

    .sidebar-header-expanded {
      display: none;
    }

    .sidebar-header-collapsed {
      padding: 0;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;

      .logo-mini :deep(svg) {
        width: 35px;
        height: 35px;
      }
    }
  }
}
</style>
